import { useState } from 'react'

import { ChatStatusEnum, getChatStatusString } from '@/entities/feedbacks'
import { PrimaryButton } from '@/shared/ui'
import { Button, Checkbox, Divider, Flex, Space } from 'antd'
import { useUnit } from 'effector-react'

import {
  $feedbacksFilters,
  feedbacksFiltersChanged,
  feedbacksFiltersReset,
} from '../../model/feedbacks-list.model'

export function FeedbackFilter() {
  const [
    { Statuses: selectedStatuses },
    handleFilterChange,
    handleFilterReset,
  ] = useUnit([
    $feedbacksFilters,
    feedbacksFiltersChanged,
    feedbacksFiltersReset,
  ])

  const [selectedOpened, setSelectedOpened] = useState(
    selectedStatuses?.includes(ChatStatusEnum.Opened) ?? false,
  )
  const [selectedClosed, setSelectedClosed] = useState(
    selectedStatuses?.includes(ChatStatusEnum.Closed) ?? false,
  )

  return (
    <>
      <Divider style={{ marginTop: 0, marginBottom: 8 }} />
      <Flex vertical gap={12}>
        Статус обращения
        <Flex vertical gap={4}>
          <Checkbox
            checked={selectedOpened && selectedClosed}
            onChange={() => {
              const checked = selectedOpened && selectedClosed
              setSelectedOpened(!checked)
              setSelectedClosed(!checked)
            }}
          >
            Выбрать все
          </Checkbox>
          <Checkbox
            checked={selectedOpened}
            onChange={() => setSelectedOpened(!selectedOpened)}
          >
            {getChatStatusString(ChatStatusEnum.Opened)}
          </Checkbox>
          <Checkbox
            checked={selectedClosed}
            onChange={() => setSelectedClosed(!selectedClosed)}
          >
            {getChatStatusString(ChatStatusEnum.Closed)}
          </Checkbox>
        </Flex>
      </Flex>
      <Space style={{ marginTop: 16 }}>
        <Button onClick={() => handleFilterReset()}>Сбросить</Button>
        <PrimaryButton
          onClick={() => {
            const statuses: Array<ChatStatusEnum> = []
            if (selectedOpened) statuses.push(ChatStatusEnum.Opened)
            if (selectedClosed) statuses.push(ChatStatusEnum.Closed)

            handleFilterChange({
              Statuses: statuses,
            })
          }}
        >
          Применить
        </PrimaryButton>
      </Space>
    </>
  )
}
